var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c(
        "div",
        {
          staticClass:
            "notification has-background-white-bis has-text-left mx-6"
        },
        [
          _c("button", {
            staticClass: "delete",
            on: { click: _vm.closeBanner }
          }),
          _vm._v(" "),
          _vm._t("default")
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }